<template>
  <div class="form-submission-status-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="statusOptions"
      display-by="label"
      value-by="value"
      :multiple="true"
      v-model="model"
      search-placeholder="Search status..."
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';

const props = defineProps({
  label: {
    type: String,
    default: 'Status'
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const statusOptions = ref([
  { label: 'Draft', value: 0 },
  { label: 'Submitted', value: 1 },
  { label: 'Approved', value: 2 },
  { label: 'Rejected', value: 4 }
]);

const handleChange = (value: number[]) => {
  emit('change', value);
};
</script>
